var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("section", { attrs: { id: "header" } }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row align-items-center row-logo" }, [
            _c(
              "div",
              {
                staticClass: "col text-center",
                attrs: { "data-aos": "fade-down", "data-aos-duration": "1500" }
              },
              [
                _c("img", {
                  staticClass: "img-fluid beneat-logo",
                  attrs: { src: "/static/img/ncs/BeNeatLOGO.png", alt: "" }
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "img-fluid ml-4 ncs-logo",
                  attrs: { src: "/static/img/ncs/ncs-logo.jpg", alt: "" }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row align-items-end" }, [
            _c("div", { staticClass: "col text-center" }, [
              _c("div", { staticClass: "mx-auto box" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-lg btn-warning text-white mb-4",
                    attrs: {
                      href: "https://line.me/R/ti/p/@BeNeat",
                      target: "_blank",
                      "data-aos": "fade-down",
                      "data-aos-duration": "1500"
                    }
                  },
                  [_vm._v("จองบริการ")]
                ),
                _vm._v(" "),
                _c(
                  "h1",
                  {
                    staticClass: "title",
                    attrs: {
                      "data-aos": "fade-down",
                      "data-aos-duration": "1500"
                    }
                  },
                  [_vm._v("บริการ กำจัดไรฝุ่น")]
                ),
                _vm._v(" "),
                _c(
                  "h2",
                  {
                    staticClass: "mt-3",
                    attrs: {
                      "data-aos": "fade-down",
                      "data-aos-duration": "1500"
                    }
                  },
                  [_vm._v('"ให้เราดูแลคุณ และ คนที่คุณรัก"')]
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("section", { attrs: { id: "alliance" } }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row align-items-center" }, [
            _c("div", { staticClass: "col text-center" }, [
              _c(
                "h2",
                {
                  attrs: {
                    "data-aos": "fade-down",
                    "data-aos-duration": "1500"
                  }
                },
                [_vm._v("พันธมิตรของเราคือใคร ?")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  attrs: { "data-aos": "fade-up", "data-aos-duration": "1500" }
                },
                [
                  _vm._v(
                    "\n            BeNeat และ NATURAL CLEANING SYSTEM ร่วมบริการ กำจัดไรฝุ่น "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n            บีนีทช่วยคุณคัดกรองบริษัททำความสะอาดชั้นนำที่มีความเชี่ยวชาญเฉพาะด้าน "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n            และมีความรับผิดชอบสูง มาให้คุณเลือกใช้บริการ คุณจึงมั่นใจได้ว่าจะได้รับบริการที่ดีเยี่ยม\n            ไม่ต่างจากการบริการของเรา\n          "
                  )
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("section", { attrs: { id: "contents" } }, [
        _c("div", { staticClass: "container-fluid p-0" }, [
          _c("div", { staticClass: "row no-gutters d-flex" }, [
            _c(
              "div",
              { staticClass: "col-12 col-md-8 d-flex align-items-end" },
              [
                _c("img", {
                  staticClass: "img-fluid",
                  attrs: {
                    src: "/static/img/ncs/1.png",
                    alt: "",
                    "data-aos": "fade-right",
                    "data-aos-duration": "1500"
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-4 d-flex flex-column" }, [
              _c(
                "div",
                { staticClass: "box-clean d-flex flex-column flex-grow-1" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "content-text",
                      attrs: {
                        "data-aos": "fade-down",
                        "data-aos-duration": "1500"
                      }
                    },
                    [
                      _c("h2", [_vm._v("TEST")]),
                      _vm._v(" "),
                      _c("p", [_vm._v("ปริมาณฝุ่นและเชื้อโรคบนที่นอน")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "bottom-line mx-auto" }, [
                        _c("hr")
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row d-none d-lg-block d-xl-block" }, [
                _c("div", { staticClass: "col-12 p-0 align-self-end" }, [
                  _c("img", {
                    staticClass: "img-fluid",
                    attrs: { src: "/static/img/ncs/2.png", alt: "" }
                  })
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row no-gutters d-flex content-bottom" }, [
            _c("div", { staticClass: "col-12 col-md-4 d-flex flex-column" }, [
              _c(
                "div",
                {
                  staticClass:
                    "box-clean text-center flex-grow-1 order-2 order-md-1",
                  attrs: {
                    "data-aos": "fade-down",
                    "data-aos-duration": "1500"
                  }
                },
                [
                  _c("h2", [_vm._v("CLEAN")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "ทำความสะอาดที่นอนและโซฟา โดยเครื่องมือที่ถูกออกแบบมา"
                    ),
                    _c("br"),
                    _vm._v(
                      " ให้มีแกนทุบ ซึ่งสามารถดึงฝุ่น\n              และเชื้อโรคออกมาได้ลึกกว่า"
                    ),
                    _c("br"),
                    _vm._v(" เครื่องทั่วไปถึง 12 เท่า")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "bottom-line mx-auto" }, [_c("hr")])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "order-1 order-md-2" }, [
                _c("img", {
                  staticClass: "img-fluid",
                  attrs: {
                    src: "/static/img/ncs/4.png",
                    alt: "",
                    "data-aos": "fade-left",
                    "data-aos-duration": "1500"
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-8 flex-column" }, [
              _c("div", {}, [
                _c("img", {
                  staticClass: "img-fluid",
                  attrs: {
                    src: "/static/img/ncs/3.png",
                    alt: "",
                    "data-aos": "fade-right",
                    "data-aos-duration": "1500"
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6 d-flex flex-column p-0" },
                  [
                    _c("div", { staticClass: "box-clean text-center" }, [
                      _c("h2", [_vm._v("UVC")]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("ฆ่าเชื้อโรคและไรฝุ่นให้ตายก่อนจะทำความสะอาด")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "bottom-line mx-auto" }, [
                        _c("hr")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-flex flex-grow-1" }, [
                      _c("img", {
                        staticClass: "img-fluid",
                        attrs: {
                          src: "/static/img/ncs/5.png",
                          alt: "",
                          "data-aos": "fade-down",
                          "data-aos-duration": "1500"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-6 p-0 d-flex" }, [
                  _c("img", {
                    staticClass: "img-fluid",
                    attrs: {
                      src: "/static/img/ncs/6.png",
                      alt: "",
                      "data-aos": "fade-right",
                      "data-aos-duration": "1500"
                    }
                  })
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("section", { attrs: { id: "recheck" } }, [
        _c("div", { staticClass: "container-fluid p-0" }, [
          _c("div", { staticClass: "row no-gutters" }, [
            _c("div", { staticClass: "col-12 col-md-4" }, [
              _c(
                "div",
                {
                  staticClass:
                    "box-clean text-center flex-grow-1 order-2 order-md-1",
                  attrs: {
                    "data-aos": "fade-left",
                    "data-aos-duration": "1500"
                  }
                },
                [
                  _c("h2", [_vm._v("RECHECK")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("ทำความสะอาดอีกครั้งหนึ่ง"),
                    _c("br"),
                    _vm._v(
                      "เพื่อให้เห็นถึงความแตกต่าง ระหว่างครั้งแรกกับครั้งที่สอง"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "bottom-line mx-auto" }, [_c("hr")])
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-md-8 content-right p-5 p-md-0" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-center flex-column h-100"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "text-center",
                        attrs: {
                          "data-aos": "fade-down",
                          "data-aos-duration": "1500"
                        }
                      },
                      [
                        _vm._v(
                          "\n              สำหรับการจองใช้บริการ หรือสอบถามข้อมูลเพิ่มเติม"
                        ),
                        _c("br"),
                        _vm._v("คุณลูกค้าสามารถ ทำการคลิกที่ปุ่มด้านล่าง"),
                        _c("br"),
                        _vm._v("เพื่อนัดหมายการใช้บริการ"),
                        _c("br"),
                        _vm._v("\n              หรือ โทร "),
                        _c(
                          "a",
                          {
                            staticClass: "text-dark",
                            attrs: { href: "tel:+6621131138" }
                          },
                          [_vm._v(" 02-113-1138 ")]
                        ),
                        _vm._v(" , "),
                        _c(
                          "a",
                          {
                            staticClass: "text-dark",
                            attrs: { href: "tel:+66927572999" }
                          },
                          [_vm._v(" 092-7572999 ")]
                        ),
                        _vm._v(" เพื่อติดต่อฝ่ายบริการของเรา\n            ")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-lg btn-warning text-white mt-4",
                        attrs: {
                          href: "https://line.me/R/ti/p/@BeNeat",
                          target: "_blank",
                          "data-aos": "fade-down",
                          "data-aos-duration": "1500"
                        }
                      },
                      [_vm._v("จองเลย")]
                    )
                  ]
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("section", { attrs: { id: "before-after" } }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "div",
              {
                staticClass:
                  "content d-flex justify-content-center align-items-center flex-column"
              },
              [
                _c(
                  "h1",
                  {
                    staticClass: "text-center",
                    attrs: {
                      "data-aos": "fade-down",
                      "data-aos-duration": "1500"
                    }
                  },
                  [_vm._v("BEFORE & AFTER")]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    attrs: {
                      "data-aos": "fade-up",
                      "data-aos-duration": "1500"
                    }
                  },
                  [_vm._v("รูปก่อน-หลังทำความสะอาด")]
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("section", { attrs: { id: "pic-before-after" } }, [
        _c("div", { staticClass: "container-fluid p-0" }, [
          _c("div", { staticClass: "row no-gutters" }, [
            _c("div", { staticClass: "col-12 col-md-4" }, [
              _c("img", {
                staticClass: "img-fluid",
                attrs: {
                  src: "/static/img/ncs/ba1.png",
                  "data-aos": "fade-left",
                  "data-aos-duration": "1500"
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-4" }, [
              _c("img", {
                staticClass: "img-fluid",
                attrs: {
                  src: "/static/img/ncs/ba2.png",
                  "data-aos": "fade-down",
                  "data-aos-duration": "1500"
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-4" }, [
              _c("img", {
                staticClass: "img-fluid",
                attrs: {
                  src: "/static/img/ncs/ba3.png",
                  "data-aos": "fade-right",
                  "data-aos-duration": "1500"
                }
              })
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("section", { attrs: { id: "satisfaction" } }, [
        _c("div", { staticClass: "container-fluid p-0" }, [
          _c(
            "div",
            {
              staticClass:
                "row no-gutters content d-flex flex-column align-items-center justify-content-center"
            },
            [
              _c("div", [
                _c(
                  "h3",
                  {
                    attrs: {
                      "data-aos": "fade-down",
                      "data-aos-duration": "1500"
                    }
                  },
                  [_vm._v("100% SATISFACTION GUARANTEED")]
                )
              ])
            ]
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0dc5aa7b", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dc5aa7b","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/Ncs.vue
// module id = 1542
// module chunks = 0